import { render, staticRenderFns } from "./Casting.vue?vue&type=template&id=e0d69c24&scoped=true&"
import script from "./Casting.vue?vue&type=script&lang=js&"
export * from "./Casting.vue?vue&type=script&lang=js&"
import style0 from "./Casting.vue?vue&type=style&index=0&id=e0d69c24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d69c24",
  null
  
)

export default component.exports